// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HbU6ypmpTS {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.HbU6ypmpTS h4 {
  line-height: 3em;
}
.HbU6ypmpTS .p6GKsiVt5k {
  float: left;
  width: 100%;
}
.HbU6ypmpTS .JwVuKr8E80 {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.HbU6ypmpTS .JwVuKr8E80:hover {
  cursor: pointer;
}
.HbU6ypmpTS .JwVuKr8E80:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.jppfubfw8s .MPQJJyD1Uh:focus {
  outline: none;
}
.jppfubfw8s .MPQJJyD1Uh.H3i4Yjjkeh.aaADvDxuv6 {
  background: #375A88;
}
.jppfubfw8s .MPQJJyD1Uh.H3i4Yjjkeh.aaADvDxuv6 span {
  color: #fff;
}
.jppfubfw8s .aaADvDxuv6 {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.jppfubfw8s .aaADvDxuv6:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.jppfubfw8s input {
  height: 38px;
  min-width: 220px;
}
.JwVuKr8E80.joYmbdlEI3 {
  background: #410102;
}
.JwVuKr8E80.Oq0mjrYNcT {
  background: #911318;
}
.JwVuKr8E80.ULf8QkbffV {
  background: #D8293B;
}
.JwVuKr8E80.KlJbqT4suE {
  background: #F2373C;
}
.JwVuKr8E80.HsWdlo0C_r {
  background: #FC4448;
}
.JwVuKr8E80.qWv7n0uDRT {
  background: #ED535E;
}
.JwVuKr8E80.oPpYGQkrmC {
  background: #E34926;
}
.JwVuKr8E80.Z3QKa_MJf7 {
  background: #FC562B;
}
.JwVuKr8E80.HAs9p5y3zr {
  background: #FC6722;
}
.JwVuKr8E80.F6kzI9NHcQ {
  background: #FD7F24;
}
.JwVuKr8E80.vbKNucYWBK {
  background: #FD8D26;
}
.JwVuKr8E80.vgE62UDlKT {
  background: #EC9C3E;
}
.JwVuKr8E80.SMnRyRE4EB {
  background: #0e673a;
}
.JwVuKr8E80.a9HPoPPYmd {
  background: #208740;
}
.JwVuKr8E80.GXjjpLiM47 {
  background: #239718;
}
.JwVuKr8E80.z8vLYRZQ3Q {
  background: #55A84D;
}
.JwVuKr8E80.pLfVJa4fLW {
  background: #4BBE5A;
}
.JwVuKr8E80.YFqFqbXaYU {
  background: #0CCA6A;
}
.JwVuKr8E80.XpBbZVXtj7 {
  background: #0A3C64;
}
.JwVuKr8E80.qaCatZyf11 {
  background: #0d487a;
}
.JwVuKr8E80.naz3t85cSG {
  background: #10538d;
}
.JwVuKr8E80.N0apHojHcA {
  background: #115A99;
}
.JwVuKr8E80.f4iYBEPw9T {
  background: #3387E2;
}
.JwVuKr8E80.WxtfPaK4ir {
  background: #1BA9CF;
}
.JwVuKr8E80.qpPWf_uz2z {
  background: #d27c02;
}
.JwVuKr8E80.LPKQAO1x9J {
  background: #fb9402;
}
.JwVuKr8E80.hKvvonaLPe {
  background: #FD9B30;
}
.JwVuKr8E80.y4GiaJ9h1m {
  background: #FDBE2D;
}
.JwVuKr8E80.hpckrO1TxA {
  background: #FED831;
}
.JwVuKr8E80.wyxUDSZSp7 {
  background: #FFFD38;
}
.JwVuKr8E80.f9k5XOCFgl {
  background: #2D215C;
}
.JwVuKr8E80.GR6PK1AFR2 {
  background: #483C83;
}
.JwVuKr8E80.iFsqYC4o3b {
  background: #58518d;
}
.JwVuKr8E80.AmRGnValWJ {
  background: #7068A9;
}
.JwVuKr8E80.mM1hArDCVz {
  background: #7f78b2;
}
.JwVuKr8E80.ZNNJFH1gxt {
  background: #8f88bc;
}
.JwVuKr8E80.UscOHkBPd0 {
  background: #000;
}
.JwVuKr8E80.M7bANnIOjr {
  background: #282626;
}
.JwVuKr8E80.m_EGSP4OUI {
  background: #242222;
}
.JwVuKr8E80.WEXsFf6xLb {
  background: #353838;
}
.JwVuKr8E80.xDlo19byRK {
  background: #666;
}
.JwVuKr8E80.WxgXOWzS_L {
  background: #999;
}
.CJCHMEyZ_P {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.CJCHMEyZ_P .GtnqWuSmp5 {
  display: none;
}
.sEhchfenOM.sEhchfenOM {
  width: auto;
  max-width: 1200px;
}
.sEhchfenOM.sEhchfenOM .X7e8nwsQTt {
  position: relative;
  background-color: #375A87;
}
.sEhchfenOM.sEhchfenOM .X7e8nwsQTt .ho96LDyXyP .R27VG4pulk {
  font-size: 20px;
}
.sEhchfenOM.sEhchfenOM .pOiwmiy3Q8 {
  margin-right: 2px;
  font-size: 20px;
}
.sEhchfenOM.sEhchfenOM .bFCGQBooT9 {
  margin-right: 2px;
  font-size: 28px !important;
}
.sEhchfenOM.sEhchfenOM .pSMSp1s67r {
  position: absolute;
  top: 12px;
  right: 18px;
}
.dYt6qts9kZ {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.dYt6qts9kZ::-webkit-scrollbar {
  display: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `HbU6ypmpTS`,
	"color-row": `p6GKsiVt5k`,
	"color-tile": `JwVuKr8E80`,
	"picker-component": `jppfubfw8s`,
	"picker-element": `MPQJJyD1Uh`,
	"active": `H3i4Yjjkeh`,
	"btn": `aaADvDxuv6`,
	"red-1": `joYmbdlEI3`,
	"red-2": `Oq0mjrYNcT`,
	"red-3": `ULf8QkbffV`,
	"red-4": `KlJbqT4suE`,
	"red-5": `HsWdlo0C_r`,
	"red-6": `qWv7n0uDRT`,
	"orange-1": `oPpYGQkrmC`,
	"orange-2": `Z3QKa_MJf7`,
	"orange-3": `HAs9p5y3zr`,
	"orange-4": `F6kzI9NHcQ`,
	"orange-5": `vbKNucYWBK`,
	"orange-6": `vgE62UDlKT`,
	"green-1": `SMnRyRE4EB`,
	"green-2": `a9HPoPPYmd`,
	"green-3": `GXjjpLiM47`,
	"green-4": `z8vLYRZQ3Q`,
	"green-5": `pLfVJa4fLW`,
	"green-6": `YFqFqbXaYU`,
	"blue-1": `XpBbZVXtj7`,
	"blue-2": `qaCatZyf11`,
	"blue-3": `naz3t85cSG`,
	"blue-4": `N0apHojHcA`,
	"blue-5": `f4iYBEPw9T`,
	"blue-6": `WxtfPaK4ir`,
	"yellow-1": `qpPWf_uz2z`,
	"yellow-2": `LPKQAO1x9J`,
	"yellow-3": `hKvvonaLPe`,
	"yellow-4": `y4GiaJ9h1m`,
	"yellow-5": `hpckrO1TxA`,
	"yellow-6": `wyxUDSZSp7`,
	"purple-1": `f9k5XOCFgl`,
	"purple-2": `GR6PK1AFR2`,
	"purple-3": `iFsqYC4o3b`,
	"purple-4": `AmRGnValWJ`,
	"purple-5": `mM1hArDCVz`,
	"purple-6": `ZNNJFH1gxt`,
	"black-1": `UscOHkBPd0`,
	"black-2": `M7bANnIOjr`,
	"black-3": `m_EGSP4OUI`,
	"black-4": `WEXsFf6xLb`,
	"black-5": `xDlo19byRK`,
	"black-6": `WxgXOWzS_L`,
	"picker-theme": `CJCHMEyZ_P`,
	"arrow-regular": `GtnqWuSmp5`,
	"review-modal__root": `sEhchfenOM`,
	"modal-header__root": `X7e8nwsQTt`,
	"modal-header__ctn": `ho96LDyXyP`,
	"modal-header__title": `R27VG4pulk`,
	"modal-header__icon": `pOiwmiy3Q8`,
	"modal-header__saveicon": `bFCGQBooT9`,
	"modal-header__closeBtn": `pSMSp1s67r`,
	"review-modal__body": `dYt6qts9kZ`
};
export default ___CSS_LOADER_EXPORT___;
